<div class="main-card mb-3 card">
  <div class="card-header d-flex justify-content-between align-items-center">
    <span class="font-weight-bold fs-1r">Support Requests</span>
  </div>

  <!-- Tabs -->
  <ul class="nav nav-tabs" id="planTabs" role="tablist">
    <li class="nav-item">
      <a
        class="nav-link active"
        id="driver-tab"
        data-bs-toggle="tab"
        href="#driver"
        role="tab"
        (click)="activeTab = 'driver'; getRequests('driver', 1)"
      >
        User Requests
      </a>
    </li>
    <li class="nav-item">
      <a
        class="nav-link"
        id="user-tab"
        data-bs-toggle="tab"
        href="#user"
        role="tab"
        (click)="activeTab = 'user'; getRequests('user', 1)"
      >
        Driver Requests
      </a>
    </li>
  </ul>

  <div class="table-responsive">
    <!-- <table
      class="align-middle mb-0 table table-borderless table-striped table-hover"
    >
      <thead>
        <tr>
          <th>Created By</th>
          <th>Phone Number</th>
          <th>Comment</th>
          <th>Driver Name</th>
          <th>Driver Phone</th>
          <th>Created At</th>
          <th class="text-end">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="
            let data of allRequests
              | paginate
                : {
                    itemsPerPage: itemsPerPage,
                    currentPage: page,
                    totalItems: totalItems
                  }
          "
        >
          <td>{{ data.createdBy?.firstName }} {{ data.createdBy?.lastName }}</td>
          <td>{{ data.createdBy?.phoneNumber }}</td>
          <td>{{ data.comment }}</td>
          <td>{{ data.driver?.firstName }} {{ data.driver?.lastName }}</td>
          <td>{{ data.driver?.phoneNumber }}</td>
          <td>{{ data.createdAt }}</td>
          <td class="text-end">
            <div class="dropdown">
              <button
                class="btn btn-sm btn-warning dropdown-toggle"
                type="button"
                id="dropdownMenuButton"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Actions
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <li>
                  <a class="dropdown-item" (click)="openEditPlan(data)">Edit</a>
                </li>
                <li>
                  <a
                    class="dropdown-item text-danger"
                    (click)="deleteSubscription(data)"
                    >Delete</a
                  >
                </li>
              </ul>
            </div>
          </td>
        </tr>
      </tbody>
    </table> -->

    <table
      class="align-middle mb-0 table table-borderless table-striped table-hover"
    >
      <thead>
        <tr>
          <th *ngIf="activeTab === 'driver'">User Name</th>
          <th *ngIf="activeTab === 'driver'">User Phone</th>

          <th *ngIf="activeTab === 'user'">Driver Name</th>
          <th *ngIf="activeTab === 'user'">Driver Phone</th>

          <th>Comment</th>

          <th *ngIf="activeTab === 'driver'">Driver Name</th>
          <th *ngIf="activeTab === 'driver'">Driver Phone</th>

          <th *ngIf="activeTab === 'user'">User Name</th>
          <th *ngIf="activeTab === 'user'">User Phone</th>

          <th>Created At</th>
          <th>Images</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="
            let data of allRequests
              | paginate
                : {
                    itemsPerPage: itemsPerPage,
                    currentPage: page,
                    totalItems: totalItems
                  }
          "
        >
          <!-- Driver tab -->
          <td>
            {{ data.createdBy?.firstName }} {{ data.createdBy?.lastName }}
          </td>
          <td>
            {{ data.createdBy?.phoneNumber }}
          </td>

          <!-- Common -->
          <td>{{ data.comment }}</td>

          <!-- Only for driver requests -->
          <td *ngIf="activeTab === 'driver'">
            {{ data.driver?.firstName }} {{ data.driver?.lastName }}
          </td>

          <td *ngIf="activeTab === 'user'">
            {{ data.user?.firstName }} {{ data.user?.lastName }}
          </td>

          <td *ngIf="activeTab === 'driver'">{{ data.driver?.phoneNumber }}</td>

          <td *ngIf="activeTab === 'user'">{{ data.user?.phoneNumber }}</td>

          <td>{{ data.createdAt | date : "short" }}</td>

          <!-- Images preview -->
          <td>
            <ng-container *ngIf="data.images?.length > 0">
              <img
                *ngFor="let img of data.images"
                [src]="img"
                width="40"
                height="40"
                class="me-1"
                style="object-fit: cover; border-radius: 4px; cursor: pointer"
                (click)="openImage(img)"
              />
            </ng-container>
          </td>

       
        </tr>
      </tbody>
    </table>

    <!-- Pagination -->
    <ngb-pagination
      (pageChange)="getRequests(activeTab, (page = $event))"
      [collectionSize]="totalItems"
      [(page)]="page"
      [pageSize]="itemsPerPage"
      [maxSize]="3"
      [rotate]="true"
      [boundaryLinks]="false"
    >
    </ngb-pagination>
  </div>

  <!-- Image Popup -->
  <div class="image-popup" *ngIf="selectedImage" (click)="closeImage()">
    <div class="popup-content" (click)="$event.stopPropagation()">
      <img [src]="selectedImage" alt="Preview" />
      <button class="close-btn" (click)="closeImage()">✕</button>
    </div>
  </div>
</div>
